import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import ImagesUpload from "react-images-upload";
import {
  base64Formatter,
  isFile,
  toBase64,
  validateURLAPI,
  validURL,
  uniqueArray,
} from "~/utils";
import PropTypes from "prop-types";
import request from "~/utils/request";
import LoadingGlobal from "./LoadingGlobal";

const InputImages = ({
  name,
  control,
  defaultValue,
  setValue,
  required,
  isSlider,
  isHero,
  imgExtension,
  singleImage,
  ...rest
}) => {
  const [base64Image, setBase64Image] = useState("");
  const [successResize, setSuccessResize] = useState(false);
  const [loadingResizeImage, setLoadingResizeImage] = useState(false);

  const labelImagesUpload = loadingResizeImage
    ? "Harap tunggu, sedang memperbaharui ukuran gambar..."
    : successResize
    ? "Ukuran gambar berhasil diperbaharui"
    : "Silakan upload foto dalam format JPG atau PNG, gambar otomatis akan di resize sesuai ukuran, tidak bisa memasukan gambar berformat .svg.";

  useEffect(() => {
    if (singleImage && defaultValue) {
      if (validURL(defaultValue)) {
        return setValue(name, defaultValue.replace("http://", "https://"));
      } else {
        return setValue(
          name,
          validateURLAPI(defaultValue.replace("http://", "https://"))
        );
      }
    } else {
      setValue(name, defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      {loadingResizeImage && <LoadingGlobal />}
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        rules={{ required: required }}
        render={({ onChange, value }) => {
          let defaultImages = "";

          if (singleImage) {
            if (isFile(value)) {
              defaultImages = [base64Formatter(base64Image)];
            } else if (value === null) {
              defaultImages = "";
            } else {
              defaultImages = [value];
            }
          } else {
            if (defaultValue && value) {
              value.map((el) => {
                if (isFile(el)) {
                  defaultImages = [
                    ...defaultImages,
                    base64Formatter(base64Image),
                  ];
                } else if (el === null) {
                  defaultImages = "";
                } else {
                  defaultImages = value;
                }
              });
            }
          }

          defaultImages =
            defaultImages?.length > 0 &&
            defaultImages?.filter((el) => typeof el === "string");

          return (
            <ImagesUpload
              {...rest}
              withIcon
              withPreview
              maxFileSize={115242880}
              singleImage={singleImage}
              label={labelImagesUpload}
              defaultImages={defaultImages}
              imgExtension={
                imgExtension
                  ? imgExtension
                  : [".jpg", ".jpeg", ".gif", ".png", ".gif", ".webp", ,]
              }
              onChange={async (images) => {
                console.log(images, "HERE");
                if (images.length > 0) {
                  images.map(async (image, index) => {
                    // formData for Resize Image
                    const formData = new FormData();

                    formData.append("image", image);

                    const urlResize = isSlider
                      ? "/v1/convert_image?tipe=slider"
                      : isHero
                      ? `/v1/convert_image?tipe=hero${isHero}`
                      : "/v1/convert_image";

                    setLoadingResizeImage(true);

                    try {
                      // resizeImage
                      const responseResize = await request.post(
                        urlResize,
                        formData,
                        {
                          responseType: "blob",
                        }
                      );

                      // setBase64Image to show preview data
                      const base64Image = await toBase64(responseResize.data);

                      // setBase64Image for defaultValue
                      setBase64Image((prevBase64Image) =>
                        uniqueArray([...prevBase64Image, base64Image])
                      );

                      // convert blob response to File Data
                      const newImageResize = new File(
                        [responseResize.data],
                        `resizeImage-${index + 1}.webp`,
                        {
                          type: "image/webp",
                        }
                      );

                      if (singleImage) {
                        onChange(newImageResize);
                      } else {
                        // send new resize image to form
                        if (value) {
                          onChange([...value, newImageResize]);
                        } else {
                          onChange([newImageResize]);
                        }
                      }
                    } finally {
                      setLoadingResizeImage(false);
                      setSuccessResize(true);

                      setTimeout(() => {
                        setSuccessResize(false);
                      }, 5000);
                    }
                  });
                }
              }}
            />
          );
        }}
      />
    </>
  );
};

InputImages.propTypes = {
  name: PropTypes.string,
  control: PropTypes.func,
  defaultValue: PropTypes.string,
  setValue: PropTypes.func,
  required: PropTypes.bool,
  isSlider: PropTypes.bool,
  isHero: PropTypes.string,
  imgExtension: PropTypes.arrayOf(PropTypes.string),
  singleImage: PropTypes.bool,
};

export default InputImages;

InputImages.defaultProps = {
  defaultValue: null,
  required: false,
  singleImage: true,
};
